export enum Messages {
    canceled = "The item canceled successfully",
    error = "Error, please try again"
}
